<template>
  <!-- 表单 -->
  <div id="list">
    <!-- 
    @submit.native.prevent
    native:对组件绑定系统原生事件
    prevrnt:提交后不刷新页面
     -->
    <el-form
      id="searchForm"
      ref="search"
      label-position="right"
      label-width="100px"
      :model="searchData"
      @submit.native.prevent
      :inline="true"
    >
      <el-row :gutter="15">
        <el-col
          v-for="col in main.search"
          :key="col.prop"
          :span="col.span"
        >
          <div
            class="searchItemBox"
            :style="{
              paddingLeft:
                col.label == undefined || col.label == ''
                  ? '0'
                  : main.base.labelWidth,
            }"
          >
            <!-- 搜索小模块标题 -->
            <span
              v-if="!(col.label == undefined || col.label == '')"
              class="searchItemTitle"
              :style="{ width: main.base.labelWidth }"
            >{{ col.label }}</span>
            <!-- 搜索按钮 -->
            <template v-if="col.type == 0">
              <el-button
                size="small"
                type="primary"
                @click="search(false)"
              >搜索</el-button>
            </template>
            <!-- 关键词搜索 -->
            <template v-else-if="col.type == 1">
              <el-input
                :placeholder="col.placeholder"
                size="small"
                clearable
                type="text"
                v-model.trim="searchData[col.prop]"
                @keyup.enter.native="search(false)"
              ></el-input>
            </template>
            <!-- 选择器单选 -->
            <template v-else-if="col.type == 2">
              <el-select
                v-model="searchData[col.prop]"
                style="width: 100%"
                size="small"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in col.options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
            <!-- 选择器多选 -->
            <template v-else-if="col.type == 3">
              <el-select
                style="width: 100%"
                v-model="searchData[col.prop]"
                size="small"
                multiple
                placeholder="请选择"
                collapse-tags
              >
                <el-option
                  v-for="(item, index) in col.options"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>
            <!-- 日期选择 -->
            <template v-else-if="col.type == 4">
              <el-date-picker
                style="width: 100%"
                v-model="searchData[col.prop]"
                type="date"
                placeholder="选择日期"
                size="small"
              >
              </el-date-picker>
            </template>
            <!-- 选择日期范围 -->
            <template v-else-if="col.type == 5">
              <el-date-picker
                v-model="searchData[col.prop]"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                size="small"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </template>
            <!-- 关键词搜索样式2 -->
            <template v-else-if="col.type == 6">
              <div class="search_content">
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="search"
                />
                <el-input
                  class="search_content_input fl"
                  :placeholder="col.placeholder"
                  size="small"
                  clearable
                  type="text"
                  v-model.trim="searchData[col.prop]"
                  @keyup.enter.native="search(false)"
                />
              </div>
            </template>
            <!-- 自定义搜索模块 -->
            <template v-else-if="col.type == 99">
              <component
                :is="col.component"
                :scope="col"
                :ref="col.ref"
                :selected="selected"
                @search="search(false)"
                @bind="bind"
              ></component>
            </template>
            <template v-else>
              <slot :name="col.prop">
                <span style="color: red; line-height: 32px; font-size: 14px">异常</span>
              </slot>
            </template>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- 列表 -排序 -->
    <el-table
      ref="table"
      :data="tableData"
      v-bind="main.table"
      v-on="main.table"
      @sort-change="sortChange"
      v-if="main.base.isShowTable"
      @selection-change="tableSelectionChanged"
    >
      <!-- 多选框 -->
      <el-table-column
        type="selection"
        v-if="main.base.select"
        width="55"
      >
      </el-table-column>

      <el-table-column
        v-if="main.base.order"
        type="index"
        label="序号"
        width="50"
      >
      </el-table-column>
      <!-- 列表内容 -->
      <el-table-column
        v-for="(field,index) in main.props"
        v-bind="field"
        :key="index"
      >

        <template slot-scope="scope">
          <template v-if="field.diy">
            <component
              :is="field.component"
              :scope="scope"
              @bind="bind"
              @search="search"
            ></component>
          </template>
          <slot
            :name="field.prop"
            v-else
            :row="scope.row"
          >
            <template v-if="field.callback!=undefined">
              <div v-html="field.callback(scope.row)"></div>
            </template>
            <template v-else-if="field.format!=undefined">{{new Date(scope.row[field.prop]).Format(field.format)}}
            </template>
            <template v-else>
              <div v-html="scope.row[field.prop]"></div>
            </template>
          </slot>
        </template>
      </el-table-column>
      <div
        slot="empty"
        class="empty"
      >
        <img src="@/assets/none.svg" />
      </div>
    </el-table>
    <!-- 分页显示 -->
    <el-pagination
      background
      :page-size="page.pageSize"
      :pager-count="5"
      layout="prev, pager, next"
      :total="page.total"
      :current-page="page.current"
      :hide-on-single-page="true"
      @current-change="pageChanged"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [], //列表数据源
      searchData() {}, //搜索模块的数据源
      selected: [], //多选选中的数据
      sortData: {}, //排序的数据源
      page: {
        pageSize: 0,
        pageCount: 0,
        total: 0,
        current: 1,
      }, //分页相关数据
    };
  },
  props: {
    //配置文件路径
    config: {
      type: String,
      default: "",
    },
  },
  methods: {
    //多选
    tableSelectionChanged(e) {
      this.selected = e;
    },
    //排序事件
    sortChange(e) {
      this.sortData = e;
      this.search();
    },
    //分页变更事件
    pageChanged(e) {
      this.$set(this.page, "current", e);
      this.search(true);
    },
    //执行页面的搜索方法，即刷新页面列表数据
    //keepPage是否保持当前页码
    search(keepPage = false) {
      // console.log("keepPage", keepPage);
      if (!keepPage) {
        this.$set(this.page, "current", 1);
      }
      var data = this.searchData.fmt();
      this.doSearch(data);
    },
    //自定义组件跟主页面通讯方法
    bind() {
      this.$emit(...arguments);
    },
    //初始化搜索条件
    initSearchData() {
      var main = this.main;
      var ret = {};
      for (const f of main.search) {
        ret[f.prop] = "";
      }
      //格式化搜索模块输出对象，即处理好:调接口时候需要传递的参数
      ret.fmt = () => {
        var sub = {};
        //判断默认排序
        if (main.base.sortBy != undefined && main.base.desc != undefined) {
          // sub.sortBy = main.base.sortBy;
          // sub.desc = main.base.desc;
          sub.sort = `${main.base.sortBy}__${main.base.desc ? "desc" : "asc"}`;
        }
        //处理查询条件，过滤有值的查询
        for (const f in ret) {
          if (typeof ret[f] != "function") {
            //判断是否为自定义搜索模块，是的话获取该自定义模块组件的result方法结果
            var diy = main.search.find((x) => x.prop == f && x.type == 99);
            if (diy == undefined) {
              var item = main.search.find((x) => x.prop == f);
              if (ret[f] != undefined && ret[f] !== "") {
                let oper = item.oper;
                //关键词
                if (item.type == 1) {
                  if (oper == undefined) {
                    oper = "l";
                  }
                  //如果有param属性，优先级param>prop
                  if (item.param != undefined) {
                    sub[item.param] = `${oper}__${ret[f]}__${ret[f]}`;
                  } else {
                    sub[f] = `${oper}__${ret[f]}__${ret[f]}`;
                  }
                }
                //单选
                else if (item.type == 2) {
                  if (oper == undefined) {
                    oper = "eq";
                  }
                  if (item.param != undefined) {
                    sub[item.param] = `${oper}__${ret[f]}__${ret[f]}`;
                  } else {
                    sub[f] = `${oper}__${ret[f]}__${ret[f]}`;
                  }
                }
                //多选
                else if (item.type == 3) {
                }
                //日期
                else if (item.type == 4) {
                }
                //日期范围
                else if (item.type == 5) {
                  if (oper == undefined) {
                    oper = "range";
                  }
                  if (item.param != undefined) {
                    sub[
                      item.param
                    ] = `${oper}__${ret[f][0]}__${ret[f][1]} 23:59:59`;
                  } else {
                    sub[f] = `${oper}__${ret[f][0]}__${ret[f][1]} 23:59:59`;
                  }
                }
                //关键词搜索样式2
                else if (item.type == 6) {
                }
                //自定义
                else if (item.type == 99) {
                }
              }
            } else {
              //如果为自定义，则自定义组件需要实现result方法，并返回待搜索结果
              const v =
                this.$refs[diy.ref][0].result != undefined
                  ? this.$refs[diy.ref][0].result()
                  : "";
              if (v != undefined && v != "" && v.length > 0) {
                sub[f] = v;
              }
            }
          }
        }
        //分页相关
        sub.page = `${this.page.current}__${this.page.pageSize}`;
        // sub.rows = this.page.pageSize;
        // 排序相关
        if (this.sortData.prop != undefined) {
          // sub.sortBy = this.sortData.prop;
          // sub.desc = this.sortData.order == "descending";
          let item = main.props.find((x) => x.prop == this.sortData.prop);
          sub.sort = `${
            item.param == undefined ? this.sortData.prop : item.param
          }__${this.sortData.order == "descending" ? "desc" : "asc"}`;
        }
        // console.log("搜索条件", sub);
        return sub;
      };
      this.searchData = ret;
    },
    // 真正执行搜索动作-调接口并处理数据
    doSearch(data) {
      this.beginLoad();
      // 调主页面搜索方法
      this.$emit("search", data, (res) => {
        // 处理接口返回值
        res.List.Each((x) => {
          x.that = this;
        });
        this.tableData = res.List;
        this.$set(
          this.page,
          "pageCount",
          (res.Count + this.page.pageSize - 1) / this.page.pageSize
        );
        this.$set(this.page, "total", res.Count);
        this.endLoad();
      });
    },
    //多层对象合并
    assiginObj(target = {}, sources = {}) {
      let obj = target;
      if (typeof target != "object" || typeof sources != "object") {
        return sources; // 如果其中一个不是对象 就返回sources
      }
      for (let key in sources) {
        // 如果target也存在 那就再次合并
        if (target.hasOwnProperty(key)) {
          obj[key] = this.assiginObj(target[key], sources[key]);
        } else {
          // 不存在就直接添加
          obj[key] = sources[key];
        }
      }
      return obj;
    },
  },

  created(e) {
    let main = this.main;
    this.$set(this.page, "pageSize", main.base.pageSize || 10);
    this.initSearchData();
    let sub = {};
    sub.page = `${this.page.current}__${this.page.pageSize}`;
    sub.sort = `${main.base.sortBy}__${main.base.desc ? "desc" : "asc"}`;
    this.doSearch(sub);
  },

  mounted() {
    // console.log("list.mounted")
  },
  computed: {
    // 处理json文件及相关动态异步组件等
    main() {
      var baseJson = this.clone(require("./list.js").default);
      var json = require(`@/views/${this.config}`);
      if (this.config.EndWith(".js")) {
        json = json.default;
      }
      //把用户自定义json和基础配置文件合并【如果用户没定义则用默认的，定义了则覆盖基础配置】
      json = this.assiginObj(baseJson, json);
      //加载自定义动态组件-自定义展示列
      for (const field of json.props) {
        if (field.sortable == undefined) {
          field.sortable = field.sort ? "custom" : false;
          field.sort = undefined;
        }
        //如果当前字段需要自定义展示，则动态加载自定义组件，路径为基础路径+字段名
        if (field.diy) {
          field.component = (resolve) =>
            require([`@/views/${json.base.path}${field.prop}.vue`], resolve);
        }
      }
      //加载自定义组件-自定义搜索模块、格式化搜索模块下拉框数据源
      for (const field of json.search) {
        // 如果当前搜索字段需要自定义，则动态加载自定义组件，路仅为基础路径+search/+字段名
        if (field.type == 99) {
          field.ref = `ref-${field.prop}`;
          field.component = (resolve) =>
            require([
              `@/views/${json.base.path}search/${field.prop}.vue`,
            ], resolve);
        } else if (field.type == 2 || field.type == 3) {
          //下拉框单选/多选
          //判断数据源类型，如果为数组，则为json枚举的数据源，如果为字符串，则为数据源方法名字，反之为空数组（json异常）
          if (!(field.options instanceof Array)) {
            if (typeof field.options == "string") {
              //为方法名字，调用父页面方法，获取数据源
              this.$emit(field.options, (res) => {
                field.options = res;
              });
            } else {
              field.options = [];
            }
          }
        }
      }
      // console.log(json);
      return json;
    },
  },
};
</script>

<style scoped lang="scss">
#searchForm {
  background: white;
  padding-top: 5px;
  padding-bottom: 15px;
}
.searchItemBox {
  width: 100%;
  padding-left: 100px;
  position: relative;
  padding-top: 4px;
  padding-bottom: 4px;
}
.searchItemTitle {
  width: 100px;
  position: absolute;
  left: 0;
  text-align: right;
  padding-right: 10px;
  line-height: 32px;
  font-size: 12px;
  color: #333;
}
.el-pagination {
  text-align: center;
  padding: 10px 0;
}
.search {
  border-bottom: 2px solid #ccc;
}
.search_content {
  width: 100%;
  height: 30px;
}
.empty {
  padding: 50px;
  img {
    width: 100px;
  }
}
</style>

<style lang="scss">
.el-table {
  border-left: 1px solid #ececef;
  border-right: 1px solid #ececef;
  .el-table td,
  .el-table th {
    padding: 7px 0 !important;
  }
}
.el-table .caret-wrapper {
  height: 23px;
  .sort-caret.ascending {
    top: 0px;
  }
  .sort-caret.descending {
    bottom: 1px;
  }
}
</style>